import { Heading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode } from 'react';
import styles from './styles.module.scss';
const cx = classnames.bind(styles);

type Props = {
  children: ReactNode;
};

export const HeaderH2: FC<Props> = ({ children }) => (
  <Heading as='h2' weight='normal' className={cx(styles['headerH2'])}>
    {children}
  </Heading>
);
